<template>
  <div class="view pa24">
    <div class="mb20">
      <span>{{ getAutoAuditText() }}</span>
      <el-switch
        @change="auditOnFun"
        class="ml10"
        v-model="switchValue"
        :active-text="getOnText()"
        :inactive-text="getOffText()"
      />
      <p class="mt10">
        {{ getAutoAuditTipText() }}
      </p>
    </div>
    {{ getSelectTimeText() }}：
    <el-date-picker
      class="ml10 mr10"
      value-format="yyyy-MM-dd"
      v-model="pickerValue"
      align="right"
              :placeholder="getSelectTimeText()"
    />
    {{ getApplicantNameText() }}：
    <el-input v-model="nickeName" class="w220 mr10" :placeholder="getApplicantNamePlaceholder()" />
    {{ getInviterNameText() }}：
    <el-input
      v-model="inviteUserName"
      class="w220 mr10"
              :placeholder="getInviterNamePlaceholder()"
    />
      {{ getApplicationStatusText() }}：
      <el-radio
        class="mr10 ml10 mt10"
        style="margin: 0"
        v-model="radio"
        label=""
        border
        size="medium"
        >{{ getAllText() }}</el-radio
      >
      <el-radio
        class="mr10 mt10"
        style="margin: 0"
        v-model="radio"
        label="0"
        border
        size="medium"
        >{{ getUnderReviewText() }}</el-radio
      >
      <el-radio
        class="mr10 mt10"
        style="margin: 0"
        v-model="radio"
        label="1"
        border
        size="medium"
        >{{ getApprovedText() }}</el-radio
      >
      <el-radio
        class="mr10 mt10"
        style="margin: 0"
        v-model="radio"
        label="2"
        border
        size="medium"
        >{{ getRejectedText() }}</el-radio
      >
      <el-button type="primary" @click="queryDistributorApp">{{ getSearchText() }}</el-button>
    <commonTable
      :tableData="tableData"
      :loading="loading"
      @handleSizeChange="handleSizeChange"
      @handleCurrentChange="handleCurrentChange"
      :currentPage="currentPage"
      :total="total"
    >
      <template v-slot:table>
        <el-table-column align="center" prop="nickeName" :label="getAvatarText()">
          <template slot-scope="scope">
            <el-image
              style="width: 36px; height: 36px"
              :src="scope.row.avatarUrl"
            >
            </el-image>
          </template>
        </el-table-column>
        <el-table-column prop="nickeName" align="center" :label="getNameText()" />
        <el-table-column prop="phone" align="center" :label="getContactText()" />
        <el-table-column prop="inviteUserName" align="center" :label="getInviterText()">
          <template slot-scope="scope">
            {{ scope.row.inviteUserName ? scope.row.inviteUserName : "-" }}
          </template>
        </el-table-column>
        <el-table-column prop="appTime" align="center" :label="getApplicationTimeText()" />
        <el-table-column align="center" prop="userType" :label="getUserTypeText()">
          <template slot-scope="scope">
            <!--普通用户 1 员工 2普通用户-->
            {{
              scope.row.userType == 1
                ? getEmployeeText()
                : scope.row.userType == 2
                ? getNormalUserText()
                : ""
            }}
          </template>
        </el-table-column>
        <el-table-column align="center" prop="appStatus" :label="getApplicationStatusText()">
          <!--                    申请状态 0 提交 1通过 2 拒绝 3 已取消-->
          <template slot-scope="scope">
            {{
              scope.row.appStatus == 0
                ? getUnderReviewText()
                : scope.row.appStatus == 1
                ? getApprovedText()
                : scope.row.appStatus == 2
                ? getRejectedText()
                : scope.row.appStatus == 3 && getCancelledText()
            }}
          </template>
        </el-table-column>
        <el-table-column align="center" :label="getOperationText()" width="170">
          <template slot-scope="scope">
            <div v-if="scope.row.appStatus == 0">
              <customPopconfirm
                confirm-button-text="确定"
                cancel-button-text="取消"
                @confirm="auditingRow(scope.row, 1)"
                icon="el-icon-info"
                icon-color="red"
                :title="getConfirmApprovalText()">
                <el-button slot="reference"  type="text" size="small">
                  {{ getApproveText() }}
                </el-button>
              </customPopconfirm>
              <el-button
                @click="auditingRow(scope.row, 2)"
                type="text"
                size="small"
                class="ml10"
              >
                {{ getRejectText() }}
              </el-button>
            </div>

            <el-button
              type="text"
              size="small"
              @click="cancelRow(scope.row, 3)"
              v-if="scope.row.appStatus == 1"
            >
              {{ scope.row.appStatus == 1 ? getCancelQualificationText() : "---" }}
            </el-button>
          </template>
        </el-table-column>
      </template>
    </commonTable>
    <el-dialog
      :title="dialogFormTitle"
      :modal-append-to-body="false"
      destroy-on-close
      width="400px"
      ref="form"
      :visible="dialogFormVisible"
    >
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
        <el-form-item prop="desc">
          <el-input type="textarea" v-model="ruleForm.desc"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">{{ getCancelText() }}</el-button>
        <el-button class="btncss" @click="cancelRowData('form')"
          >{{ getConfirmText() }}</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import commonTable from "@/components/common/commonTable";
import customPopconfirm from "@/components/common/customPopconfirm";
import {
  queryDistributorApp,
  cancelDistributorApp,
  verifyDistributorApp,
  updateAuditSettings,
  queryAuditSettings,
} from "@/api/distribution";
import i18nMixin from '@/mixins/i18nMixin';

export default {
  mixins: [i18nMixin],
  name: "personnelApplication",
  components: {
    commonTable,
    customPopconfirm
  },
  data() {
    return {
      switchValue: true,
      radio: "",
      pickerValue: "",
      tableData: [],
      currentPage: 1, //当前页
      pageSize: 10, //显示条数
      pageSize2: 10, //显示条数
      loading: false, //表格加载
      total: 0, //总条数
      nickeName: "",
      inviteUserName: "",
      dialogFormTitle: "请输入拒绝理由",
      dialogFormVisible: false,
      ruleForm: { desc: "" },
      rules: {
        desc: [{ required: true, message: "请输入", trigger: "blur" }],
      },
      currentRow: {},
      appStatus: "",
    };
  },
  created() {
    this.queryDistributorApp();
    this.queryAudit();
    
    // 监听语言变化，强制更新组件
    this.$root.$on('language-changed', () => {
      this.$forceUpdate();
    });
  },
  beforeDestroy() {
    // 清理事件监听
    this.$root.$off('language-changed');
  },
  methods: {
    async queryDistributorApp() {
      let data = {
        appTime: this.pickerValue,
        pageSize: this.pageSize,
        pageNum: this.currentPage,
        nickeName: this.nickeName,
        inviteUserName: this.inviteUserName,
        appStatus: this.radio,
      };
      try {
        this.loading = true;
        const result = await queryDistributorApp(data);
        this.loading = false;
        
        // 添加安全检查，确保result和result.data存在
        if (result && result.data) {
          const {
            pageInfo: { total, list },
          } = result.data;
          this.tableData = list || [];
          this.total = total || 0;
          
          // 添加安全检查，确保每个item都有必要的属性
          this.tableData.forEach(item => {
            // 确保item存在且有必要的属性
            if (item) {
              // 为可能不存在的属性设置默认值
              item.isTurnOn = item.isTurnOn || false;
              item.status = item.status || '';
              item.createTime = item.createTime || '';
              // 其他可能需要的属性...
            }
          });
        } else {
          this.tableData = [];
          this.total = 0;
        }
      } catch (error) {
        this.loading = false;
        console.error('获取人员申请列表失败:', error);
        this.tableData = [];
        this.total = 0;
      }
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.queryDistributorApp();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.queryDistributorApp();
    },
    cancelRow(row) {
      this.dialogFormVisible = true;
      this.dialogFormTitle = "请输入取消理由";
      this.currentRow = row;
      this.appStatus = 3;
    },
    async cancelRowData() {
      this.$refs.ruleForm.validate(async (valid) => {
        if (valid) {
          this.currentRow.note = this.ruleForm.desc;
          this.currentRow.appStatus = this.appStatus;
          const data = this.currentRow
          try {
            await cancelDistributorApp(data)
            this.dialogFormVisible = false;
            await this.queryDistributorApp();
          } catch (error) {
            this.dialogFormVisible = false;
            console.log(error);
          }
        } else {
          console.log("error submit!!");
          console.log(this.ruleForm);
          return false;
        }
      });
    },
    async queryAudit() {
      try {
        const result = await queryAuditSettings({ xxx: "x" });
        const {
          data: { isTurnOn },
        } = result;
        this.switchValue = isTurnOn;
      } catch (error) {
        console.log(error);
      }
    },
    async auditingRow(row, type) {
      
      if (type == 1) {
        row.appStatus = 1;
        let data = row
        await verifyDistributorApp(data);
        await this.queryDistributorApp();
      } else {
        this.appStatus = 2;
        this.currentRow = row;
        this.dialogFormTitle = "请输入拒绝理由";
        this.dialogFormVisible = true;
      }
    },
    async auditOnFun() {
      try {
        await updateAuditSettings(
          { isTurnOn: this.switchValue },
          { showLoading: true }
        );
      } catch (error) {
        console.log(error);
      }
    },
    
    // 多语言方法
    getCurrentLanguage() {
      let currentLanguage = this.$store.state.currentLanguage;
      if (!currentLanguage) {
        currentLanguage = localStorage.getItem('language') || 'zh-TW';
      }
      return currentLanguage;
    },
    
    getAutoAuditText() {
      const currentLanguage = this.getCurrentLanguage();
      const textMap = {
        'zh-CN': '自动审核',
        'zh-TW': '自動審核',
        'en': 'Auto Audit'
      };
      return textMap[currentLanguage] || '自动审核';
    },
    
    getOnText() {
      const currentLanguage = this.getCurrentLanguage();
      const textMap = {
        'zh-CN': '开',
        'zh-TW': '開',
        'en': 'On'
      };
      return textMap[currentLanguage] || '开';
    },
    
    getOffText() {
      const currentLanguage = this.getCurrentLanguage();
      const textMap = {
        'zh-CN': '关',
        'zh-TW': '關',
        'en': 'Off'
      };
      return textMap[currentLanguage] || '关';
    },
    
    getAutoAuditTipText() {
      const currentLanguage = this.getCurrentLanguage();
      const textMap = {
        'zh-CN': '提示：开启自动审核后，用户提交了分销员申请，系统会自动审核通过申请',
        'zh-TW': '提示：開啟自動審核後，用戶提交了分銷員申請，系統會自動審核通過申請',
        'en': 'Tip: After enabling auto audit, when users submit distributor applications, the system will automatically approve them'
      };
      return textMap[currentLanguage] || '提示：开启自动审核后，用户提交了分销员申请，系统会自动审核通过申请';
    },
    
    getSelectTimeText() {
      const currentLanguage = this.getCurrentLanguage();
      const textMap = {
        'zh-CN': '选择时间',
        'zh-TW': '選擇時間',
        'en': 'Select Time'
      };
      return textMap[currentLanguage] || '选择时间';
    },
    
    getApplicantNameText() {
      const currentLanguage = this.getCurrentLanguage();
      const textMap = {
        'zh-CN': '申请人姓名',
        'zh-TW': '申請人姓名',
        'en': 'Applicant Name'
      };
      return textMap[currentLanguage] || '申请人姓名';
    },
    
    getApplicantNamePlaceholder() {
      const currentLanguage = this.getCurrentLanguage();
      const textMap = {
        'zh-CN': '请输入申请人姓名',
        'zh-TW': '請輸入申請人姓名',
        'en': 'Please enter applicant name'
      };
      return textMap[currentLanguage] || '请输入申请人姓名';
    },
    
    getInviterNameText() {
      const currentLanguage = this.getCurrentLanguage();
      const textMap = {
        'zh-CN': '邀请人姓名',
        'zh-TW': '邀請人姓名',
        'en': 'Inviter Name'
      };
      return textMap[currentLanguage] || '邀请人姓名';
    },
    
    getInviterNamePlaceholder() {
      const currentLanguage = this.getCurrentLanguage();
      const textMap = {
        'zh-CN': '请输入邀请人姓名',
        'zh-TW': '請輸入邀請人姓名',
        'en': 'Please enter inviter name'
      };
      return textMap[currentLanguage] || '请输入邀请人姓名';
    },
    
    getApplicationStatusText() {
      const currentLanguage = this.getCurrentLanguage();
      const textMap = {
        'zh-CN': '申请状态',
        'zh-TW': '申請狀態',
        'en': 'Application Status'
      };
      return textMap[currentLanguage] || '申请状态';
    },
    
    getAllText() {
      const currentLanguage = this.getCurrentLanguage();
      const textMap = {
        'zh-CN': '全部',
        'zh-TW': '全部',
        'en': 'All'
      };
      return textMap[currentLanguage] || '全部';
    },
    
    getUnderReviewText() {
      const currentLanguage = this.getCurrentLanguage();
      const textMap = {
        'zh-CN': '审核中',
        'zh-TW': '審核中',
        'en': 'Under Review'
      };
      return textMap[currentLanguage] || '审核中';
    },
    
    getApprovedText() {
      const currentLanguage = this.getCurrentLanguage();
      const textMap = {
        'zh-CN': '已通过',
        'zh-TW': '已通過',
        'en': 'Approved'
      };
      return textMap[currentLanguage] || '已通过';
    },
    
    getRejectedText() {
      const currentLanguage = this.getCurrentLanguage();
      const textMap = {
        'zh-CN': '已拒绝',
        'zh-TW': '已拒絕',
        'en': 'Rejected'
      };
      return textMap[currentLanguage] || '已拒绝';
    },
    
    getSearchText() {
      const currentLanguage = this.getCurrentLanguage();
      const textMap = {
        'zh-CN': '搜索',
        'zh-TW': '搜索',
        'en': 'Search'
      };
      return textMap[currentLanguage] || '搜索';
    },
    
    getAvatarText() {
      const currentLanguage = this.getCurrentLanguage();
      const textMap = {
        'zh-CN': '头像',
        'zh-TW': '頭像',
        'en': 'Avatar'
      };
      return textMap[currentLanguage] || '头像';
    },
    
    getNameText() {
      const currentLanguage = this.getCurrentLanguage();
      const textMap = {
        'zh-CN': '姓名',
        'zh-TW': '姓名',
        'en': 'Name'
      };
      return textMap[currentLanguage] || '姓名';
    },
    
    getContactText() {
      const currentLanguage = this.getCurrentLanguage();
      const textMap = {
        'zh-CN': '联系方式',
        'zh-TW': '聯繫方式',
        'en': 'Contact'
      };
      return textMap[currentLanguage] || '联系方式';
    },
    
    getInviterText() {
      const currentLanguage = this.getCurrentLanguage();
      const textMap = {
        'zh-CN': '邀请人',
        'zh-TW': '邀請人',
        'en': 'Inviter'
      };
      return textMap[currentLanguage] || '邀请人';
    },
    
    getApplicationTimeText() {
      const currentLanguage = this.getCurrentLanguage();
      const textMap = {
        'zh-CN': '申请时间',
        'zh-TW': '申請時間',
        'en': 'Application Time'
      };
      return textMap[currentLanguage] || '申请时间';
    },
    
    getUserTypeText() {
      const currentLanguage = this.getCurrentLanguage();
      const textMap = {
        'zh-CN': '用户类别',
        'zh-TW': '用戶類別',
        'en': 'User Type'
      };
      return textMap[currentLanguage] || '用户类别';
    },
    
    getEmployeeText() {
      const currentLanguage = this.getCurrentLanguage();
      const textMap = {
        'zh-CN': '员工',
        'zh-TW': '員工',
        'en': 'Employee'
      };
      return textMap[currentLanguage] || '员工';
    },
    
    getNormalUserText() {
      const currentLanguage = this.getCurrentLanguage();
      const textMap = {
        'zh-CN': '普通用户',
        'zh-TW': '普通用戶',
        'en': 'Normal User'
      };
      return textMap[currentLanguage] || '普通用户';
    },
    
    getCancelledText() {
      const currentLanguage = this.getCurrentLanguage();
      const textMap = {
        'zh-CN': '已取消',
        'zh-TW': '已取消',
        'en': 'Cancelled'
      };
      return textMap[currentLanguage] || '已取消';
    },
    
    getOperationText() {
      const currentLanguage = this.getCurrentLanguage();
      const textMap = {
        'zh-CN': '操作',
        'zh-TW': '操作',
        'en': 'Operation'
      };
      return textMap[currentLanguage] || '操作';
    },
    
    getConfirmApprovalText() {
      const currentLanguage = this.getCurrentLanguage();
      const textMap = {
        'zh-CN': '确认通过审核吗？',
        'zh-TW': '確認通過審核嗎？',
        'en': 'Confirm approval?'
      };
      return textMap[currentLanguage] || '确认通过审核吗？';
    },
    
    getApproveText() {
      const currentLanguage = this.getCurrentLanguage();
      const textMap = {
        'zh-CN': '通过',
        'zh-TW': '通過',
        'en': 'Approve'
      };
      return textMap[currentLanguage] || '通过';
    },
    
    getRejectText() {
      const currentLanguage = this.getCurrentLanguage();
      const textMap = {
        'zh-CN': '拒绝',
        'zh-TW': '拒絕',
        'en': 'Reject'
      };
      return textMap[currentLanguage] || '拒绝';
    },
    
    getCancelQualificationText() {
      const currentLanguage = this.getCurrentLanguage();
      const textMap = {
        'zh-CN': '取消资格',
        'zh-TW': '取消資格',
        'en': 'Cancel Qualification'
      };
      return textMap[currentLanguage] || '取消资格';
    },
    
    getCancelText() {
      const currentLanguage = this.getCurrentLanguage();
      const textMap = {
        'zh-CN': '取 消',
        'zh-TW': '取 消',
        'en': 'Cancel'
      };
      return textMap[currentLanguage] || '取 消';
    },
    
    getConfirmText() {
      const currentLanguage = this.getCurrentLanguage();
      const textMap = {
        'zh-CN': '确 定',
        'zh-TW': '確 定',
        'en': 'Confirm'
      };
      return textMap[currentLanguage] || '确 定';
    },
  },
};
</script>

<style lang="scss" scoped>
</style>